import styled from 'styled-components';

export const SelectInput = styled.select<any>`
  box-sizing: border-box;
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2.5rem 0 0.5rem;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #959fa8;
  color: #1b2126;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M4 6L8 10L12 6H4Z' fill='currentColor' /%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position:
    right 0.5em top 50%,
    0 0;

  ${({ sizeVariant }) => {
    let height = '40px';
    let fontSize = '14px';

    if (sizeVariant === 'sm') {
      height = '32px';
      fontSize = '12px';
    }

    return `
      height: ${height};
      font-size: ${fontSize};
    `;
  }}

  &:focus {
    border-color: #0079d1;
    box-shadow: 0 0 0 4px #80bce8;
    outline: 0;
  }

  &:invalid {
    border-color: #eb5757;
    box-shadow: 0 0 0 4px #f7bcbc;
    outline: 0;
  }

  &:disabled {
    box-shadow: none;
    background-color: #f2f3f5;
    border-color: #959fa8;
    color: #637381;
    cursor: not-allowed;
  }
`;
